import { render, staticRenderFns } from "./AssignStore.vue?vue&type=template&id=9d93a940&"
import script from "./AssignStore.vue?vue&type=script&lang=js&"
export * from "./AssignStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports